import { render, staticRenderFns } from "./CustomerListExpandedContent.vue?vue&type=template&id=55ff8493&scoped=true"
import script from "./CustomerListExpandedContent.vue?vue&type=script&lang=js"
export * from "./CustomerListExpandedContent.vue?vue&type=script&lang=js"
import style0 from "./CustomerListExpandedContent.vue?vue&type=style&index=0&id=55ff8493&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ff8493",
  null
  
)

export default component.exports